import Request from "@liejy/request";
import md5 from "js-md5";
import { isMobile } from "../../static/js/common";

const key = "MDc1ZDJlZWQ1YjUxY2FhMTRjN2VjODY5NmE4MjBjOTgy";
function getSign() {
  const ts = Date.now();
  const reqType = isMobile() ? 2 : 1;
  const signKey = window.btoa(key).substring(1);
  const sign = md5(ts + "|" + reqType + "|" + signKey);
  return { ts, reqType, sign };
}

const request = new Request({
  baseURL: process.env.NODE_ENV=="development" ? 'https://website.zxzt168.com/website' : 'https://website.zxzt168.com/website/',//https://websitetest.zxzt168.com/website/
  successMap: { code: 200 },
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  interceptors: {
    // 实例请求拦截
    requestInterceptors: (config) => {
      if (config.method.toUpperCase() === "POST") {
        const sign = getSign();
        config.data = Object.assign({}, sign, config.data);
      }
      return config;
    },
    // 实例响应拦截
    responseInterceptors: (result) => {
      return result;
    },
  },
});

export const http = (config) => {
  return request.request(config);
};

export const cancelRequest = (url) => {
  return request.cancelRequest(url);
};

export const cancelAllRequest = () => {
  return request.cancelAllRequest();
};

export default http;



// WEBPACK FOOTER //
// ./src/api/axios.js